export default(function(value){return value===undefined;});